import { PDFDocument } from 'pdf-lib'

/**
 * Creates pdf-lib doc from `jsPdfDoc` and pdfs.
 * We can not attach pdfs using jspdf library, so it is done with pdf-lib.
 * @param {jsPDF} jsPdfDoc
 * @param {AttachedResources} attachedResources
 */
export async function getDocWithAppendedPdfs (jsPdfDoc, attachedResources) {
  return PDFDocument.load(jsPdfDoc.output('arraybuffer'))
    .then(async doc => {
      let i = 0 // index that should point to page index to which insert pdfs

      for (let pdfI = 0; pdfI < attachedResources.pdfs.length; ++pdfI) {
        let rawPdfs = attachedResources.pdfs[pdfI]

        // For blue pages
        i += 2; // two pages with frame
        i += attachedResources.imgsWithDimensions[pdfI].length // number of attached imgs
        for (let q = 0; q < rawPdfs.length; ++q) {
          let rawPdf = rawPdfs[q]
          let attachedPdf = await PDFDocument.load(rawPdf)
          for (let pageI = 0; pageI < attachedPdf.getPageCount(); ++pageI) {
            const [page] = await doc.copyPages(attachedPdf, [pageI])
            doc.insertPage(i, page)
            i += 1
          }
        }
        // For red pages
        i += 2 // two pages with frame
        i += attachedResources.imgsWithDimensions[pdfI].length // number of attached imgs
        for (let q = 0; q < rawPdfs.length; ++q) {
          let rawPdf = rawPdfs[q]
          let attachedPdf = await PDFDocument.load(rawPdf)
          for (let pageI = 0; pageI < attachedPdf.getPageCount(); ++pageI) {
            const [page] = await doc.copyPages(attachedPdf, [pageI])
            doc.insertPage(i, page)
            i += 1
          }
        }
      }
      return doc
    })
}
